import axios from 'axios';
import router from "../router"
import { Toast, Indicator } from "mint-ui";
import params from "../service/params"
// axios.defaults.withCredentials = true
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {

  return Promise.reject(error)
});
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    Indicator.close()
    if (response.data) {
      if (response.data.Code == 0) {
        return response.data.Data;
      } else if (response.data.Code == 100) {
        let ReUrl=encodeURIComponent(window.location.href);
        window.location.href=params.BASE_URL+`?ReUrl=${ReUrl}&RegType=4`;
        return;
      } else {
        Toast({
          message: response.data.Message,
          position: "bottom"
        })
        return Promise.reject(response.data);
      }
    }
    return response;
  },
  error => {
    Indicator.close()
    Toast({
      message: '网络开了点小差～',
      position: "bottom",
    })
    return Promise.reject(error.response)
  });



// WEBPACK FOOTER //
// ./src/service/config.js